import $ from 'jquery';

$('.show-more-dates').on('click', () => {
    $('.show-more-dates').fadeOut();
    $('.new-dates').fadeIn();
});
